import { render, staticRenderFns } from "./CollapseTable.vue?vue&type=template&id=6b63fda9&scoped=true"
import script from "./CollapseTable.vue?vue&type=script&lang=js"
export * from "./CollapseTable.vue?vue&type=script&lang=js"
import style0 from "./CollapseTable.vue?vue&type=style&index=0&id=6b63fda9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b63fda9",
  null
  
)

export default component.exports